import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/nl';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import Avatar from '../../../Avatar';
import CoreLink from '../../../CoreLink';
import type { SearchForumCategoryPostsHit } from '../../types';

moment.locale('nl');

export interface SearchForumCategoryPostsResultsHitProps {
  hit: SearchForumCategoryPostsHit;
  uid?: number;
}

const SearchForumCategoryPostsResultsHit: React.FC<
SearchForumCategoryPostsResultsHitProps
> = (props) => {
  const { hit, uid } = props;
  const { t } = useTranslation();

  const url = hit.url[0];
  const nid = hit.post_id[0];
  const title = hit.post_title[0];
  const body = hit.post_body_processed?.[0];
  const authorAvatar = hit.post_author_avatar?.[0] || 1;
  const authorNickname = hit.post_author_nickname?.[0] || t('pages.forum.anonymous');
  const lastCommentTimestamp = hit.post_last_comment_timestamp[0];
  const lastCommentDate = moment.unix(lastCommentTimestamp);
  const commentCount = hit.post_comment_count[0];
  const isFollowing = hit.post_follow_uids?.includes(uid);

  return (
    <div className="ForumCategoryPost" key={nid}>
      <div className="ForumCategoryPost__title-wrapper">
        {isFollowing && (
          <div className="ForumCategoryPost__bookmark">
            <i className="icon icon-bookmark icon-size-sm icon-variant-7" />
          </div>
        )}

        <CoreLink href={url} className="ForumCategoryPost__title u-word-break">
          {title}
        </CoreLink>
      </div>

      {body && (
        <WysiwygField
          className="ForumCategoryPost__description"
          property="schema:text"
          html={body}
        />
      )}

      <footer className="ForumCategoryPost__meta">
        {authorNickname && authorAvatar && (
          <div className="ForumCategoryPost__meta-item">
            <Avatar avatar={authorAvatar} />
            <span className="ForumCategoryPost__meta-value">{authorNickname}</span>
          </div>
        )}

        <div className="ForumCategoryPost__meta-item">
          <i className="icon icon-conversation" />
          <span className="ForumCategoryPost__meta-label">
            {t('pages.forum.posts.labels.last_response')}
          </span>
          <span className="ForumCategoryPost__meta-value">
            {lastCommentTimestamp !== 0 && commentCount !== 0
              ? lastCommentDate.fromNow()
              : t('pages.forum.posts.labels.no_response')}
          </span>
        </div>

        <div className="ForumCategoryPost__meta-item">
          <span className="ForumCategoryPost__meta-label">
            <i className="icon icon-balloon" />
            {t('pages.forum.posts.labels.number_of_responses')}
          </span>
          <span className="ForumCategoryPost__meta-value">{commentCount}</span>
        </div>
      </footer>
    </div>
  );
};

export default SearchForumCategoryPostsResultsHit;
